import React from 'react';

export default props => {
  return (
    <div className="arrow" style={props.style || {}}>
      {props.label && <div className="arrow__label">{props.label}</div>}
      <div className="arrow__circle"></div>
      <div className="arrow__arrow"></div>
    </div>
  );
};
